import React, { useContext, createContext, useReducer } from 'react';
import { ACTIONS_USER } from '../utils/_constants'
import { getCookie, setCookie, deleteCookie, verifyAuthToken} from '../utils/tools';
import { saveFavoritesOnLocalStorage } from './favorites-context';
export const ACTIONS = ACTIONS_USER;
const USER_LOCALSTORAGE_NAME = 'user_local';

const UserContext = createContext();
const UserUpdateContext = createContext();

export const useUser = () => useContext(UserContext);
export const useUserUpdate = () => useContext(UserUpdateContext);

export const saveUserDataOnLocalStorage = user => localStorage.setItem(USER_LOCALSTORAGE_NAME, user);
export const getUserDataFromLocalStorage = () => localStorage.getItem(USER_LOCALSTORAGE_NAME);

const resetUser = () => {
	saveUserDataOnLocalStorage('guest');
	deleteCookie('authToken');
}

const getCurrentUser = () => {    
	
	if(getUserDataFromLocalStorage() !== 'guest' && getCookie('authToken')) {

		if(verifyAuthToken(getCookie('authToken'))){ // TODO make sure authToken belongs to specific user by decrypting JWT
			return {username: getUserDataFromLocalStorage()}
		} else return {username: 'guest'};
	} else {
		saveUserDataOnLocalStorage('guest');
		return {username: 'guest'};
	}	
}

const initialUser = getCurrentUser();

export function UserProvider({children}){  
	
	function userReducer(user, action) {
			switch (action.type) {
				case ACTIONS.LOGIN: {  				
					user = action.payload;
					saveUserDataOnLocalStorage(user.username);				
					setCookie('authToken', user.authToken, 1); // non secure cookie due to api issues
					return user;
				} 
				case ACTIONS.LOGOUT: {	
					saveFavoritesOnLocalStorage({launches: {}, pads: {}});	
					resetUser();
					user = {username: 'guest'};
					return user;
				}
				default:
					throw Error ('Unsupported Favorites Action');
			}
	}

	const [user, dispatch] = useReducer(userReducer, initialUser);

	return (
		<UserContext.Provider value={user}>
			<UserUpdateContext.Provider value={dispatch}>
				{ children }
			</UserUpdateContext.Provider>
		</UserContext.Provider>
	)
}
